require('../../../../styles/blocks/_modal.scss');
require('../../../../styles/blocks/_blowup-modal.scss');
require('./RAModal.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Modal = require('react-bootstrap/lib/Modal');
const classNames = require('classnames');
// @ icons
const closeIcon = require('assets/icons/close.svg');

class RAModal extends React.Component {
    render() {
        const { logo, title, text, show, hide, classButtons, firstButton, firstAction, secondButton, secondAction } =
            this.props;
        const onClickAction = firstAction ? firstAction : hide;
        const buttonClass = classNames('validation-buttons', classButtons);
        const primaryButtonClass = classNames({ 'validation-buttons__primary--warning': secondButton });
        const titleClass = classNames('title', { 'title--warning': secondButton });
        const bodyClass = classNames({ 'modal-body--warning': secondButton });

        return (
            <span>
                <Modal
                    show={show}
                    onHide={hide}
                    className="ra-modal-override"
                    dialogClassName="ra-modal"
                    backdrop="static"
                    animation={true}
                >
                    <Modal.Header>
                        <div className="close-icon">
                            <a
                                href="#"
                                onClick={event => {
                                    event.preventDefault();
                                    hide();
                                }}
                            >
                                <img src={closeIcon} />
                            </a>
                        </div>
                        <div className={titleClass}>
                            {logo && <img src={logo} />}
                            <h5>{title}</h5>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={bodyClass}>{text}</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className={buttonClass}>
                            <span className="validation-buttons__secondary">
                                {secondButton && <button onClick={secondAction}>{secondButton}</button>}
                            </span>

                            <span className={primaryButtonClass}>
                                <button onClick={onClickAction}>{firstButton}</button>
                            </span>
                        </div>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
}

RAModal.propTypes = {
    logo: PropTypes.string,
    title: PropTypes.any.isRequired,
    text: PropTypes.string,
    classButtons: PropTypes.string,
    firstButton: PropTypes.string.isRequired,
    secondButton: PropTypes.string,
    firstAction: PropTypes.func,
    secondAction: PropTypes.func,
    show: PropTypes.bool,
    hide: PropTypes.func,
};

module.exports = RAModal;
